import moment from 'moment';
import uniq from 'lodash-es/uniq';
import flatten from 'lodash-es/flatten';

export function filterOutList(list, filterType) {
  let result = {};
  list.map(item => {
    Object.keys(item).map(key => {
      let value = item[key];
      if (key === 'aliases') {
        return;
      }
      if (key === 'firstName' || key === 'lastName') {
        key = 'name';
        value = item.firstName + ' ' + item.lastName;
      }

      if (!result[key]) {
        result[key] = [];
      }

      if (filterType === 'coupons' && key === 'title') {
        result[key].push({
          value: `${item.couponID}`,
          key: `${item.couponID}`,
          title: value,
          children: (item.aliases || [])
            .filter(childItem => childItem.status === 'active')
            .map(childItem => ({
              value: `${item.couponID}#-#${childItem.couponAliasID}`,
              key: `${item.couponID}#-#${childItem.couponAliasID}`,
              title: childItem.name,
              isLeaf: true
            }))
        });
      } else if (Array.isArray(value)) {
        result[key] = uniq([...result[key], ...flatten(value)]);
      } else if (value) {
        result[key] = uniq([...result[key], value]);
      }
    });
  });

  return result;
}

export function filterItems(data, filters) {
  let newData = data;
  Object.keys(filters).forEach(key => {
    let value = filters[key];
    if (key === 'couponID') {
      value = value.map(item => {
        const splits = item.toString().split('#-#');
        return splits[0];
      });
    }
    if (value.length > 0) {
      newData = newData.filter(d => {
        const dataVal = d[key];
        if (
          key === 'createdAt' ||
          key === 'expireAt' ||
          key === 'firstDayOfService'
        ) {
          return (
            moment.utc(dataVal).isAfter(moment(value[0])) &&
            moment.utc(dataVal).isBefore(moment(value[1]))
          );
        } else if (key === 'name') {
          const { firstName, lastName, name } = d;
          return firstName
            ? value.includes(firstName + ' ' + lastName)
            : value.includes(name);
        } else if (key === 'couponID') {
          return value.includes(dataVal.toString());
        } else if (key === 'bedroomsCounts' || key === 'buildingsNames') {
          return (
            dataVal &&
            dataVal.filter(item => value.includes(item.toString())).length > 0
          );
        } else if (key === 'active') {
          return dataVal.toString() === value[0];
        } else {
          return dataVal && value.includes(dataVal.toString());
        }
      });
    }
  });
  return newData;
}

export function sorter(a, b) {
  return (a === null) - (b === null) || +(a > b) || -(a < b);
}

export function paginateItems(data, currentPage, noOfItemsToDisplay) {
  return data.slice(
    (currentPage - 1) * noOfItemsToDisplay,
    currentPage * noOfItemsToDisplay
  );
}
